import { Button, Chip, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography, Box, CircularProgress } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { FetchBranchShowData, FetchClassTypeShowData, FetchSectionShowData, FetchSemesterShowData, FetchSpecializationShowData, GetSectionReport, GetStudentReportView, GetSubject, GetSubjectReport, LocationShowdata } from '../../services/LoginPageService';
import StudentReportTools from './StudentReportTools'
import { attendanceColor } from '../../utils/helperFunctions';
import { DownloadStudentReport } from '../../services/DownloadCsvReportsService';
import NotificationBar from '../notification/ServiceNotificationBar';

const StudentReport = () => {
  const [month,setMonth]=useState('');
  const [location,setLocation]=useState('');
  const [locationList,setLocationList]=useState([]);
  const[branch,setBranch]=useState('');
  const[branchList,setBranchList]=useState([]);
  const[specialization,setSpecialization]=useState('');
  const[specializationList,setSpecializationList]=useState([]);
  const[semester,setSemester]=useState('');
  const[semesterList,setSemesterList]=useState([]);
  const[subject,setSubject]=useState('');
  const[subjectList,setSubjectList]=useState([]);
  const[section,setSection]=useState('');
  const[sectionList,setSectionList]=useState([]);
  const [rows,setRows]=useState([]);
  const [isAddButton, setIsAddButton] = useState(true);
  const [editClassName, setEditClassName] = useState('');
  const [downloadDisabled,setDownloadDisabled]=useState(true);
  const [open, setOpen] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  const [classTypedataList,setClassTypeDataList] = useState([])
           const [classType, setClassType] = useState('');
           const [loading, setLoading] = useState(false);
  const [openNotification, setNotification] = useState({
    status: false,
    type: 'error',
    message: '',
  });


const columns = [
  {
      field: 'registrationNo',
      headerName: 'Registration No',
      type:'number',
      sortable:'true',
      headerClassName: 'super-app-theme--header',
      minWidth: 120, flex: 1, align: 'center', headerAlign: 'center'
    },
    {
      field: 'studentId',
      headerName: 'Student Id',
      headerClassName: 'super-app-theme--header',
      minWidth: 90, flex: 1, align: 'center', headerAlign: 'center'
    },
    
    {
      field: 'studentName',
      headerName: 'Name',
      headerClassName: 'super-app-theme--header',
      minWidth:150, flex: 1, align: 'left', headerAlign: 'center'
    },
  {
  field: 'date1',
  headerName: '1',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date1;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date2',
  headerName: '2',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date2;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date3',
  headerName: '3',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date3;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date4',
  headerName: '4',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date4;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date5',
  headerName: '5',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date5;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date6',
  headerName: '6',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date6;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date7',
  headerName: '7',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date7;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date8',
  headerName: '8',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date8;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date9',
  headerName: '9',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date9;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date10',
  headerName: '10',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date10;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date11',
  headerName: '11',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date11;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date12',
  headerName: '12',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date12;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date13',
  headerName: '13',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date13;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date14',
  headerName: '14',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date14;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date15',
  headerName: '15',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date15;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date16',
  headerName: '16',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date16;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date17',
  headerName: '17',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date17;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date18',
  headerName: '18',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date18;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date19',
  headerName: '19',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date19;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date20',
  headerName: '20',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date20;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date21',
  headerName: '21',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date21;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date22',
  headerName: '22',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date22;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date23',
  headerName: '23',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date23;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date24',
  headerName: '24',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date24;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date25',
  headerName: '25',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date25;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date26',
  headerName: '26',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date26;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date27',
  headerName: '27',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date27;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date28',
  headerName: '28',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date28;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date29',
  headerName: '29',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date29;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date30',
  headerName: '30',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date30;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
{
  field: 'date31',
  headerName: '31',
  minWidth: 50,
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => {
    const value = params.row.date31;
    const colors = attendanceColor("", value);
    if (Array.isArray(colors)) {
      const parts = value.split('|');
      return (
        <div>
          {parts.map((part, i) => (
            <Typography key={i} component="span" style={{ color: colors[i], marginRight: 4 }}>
              {part}
            </Typography>
          ))}
        </div>
      );
    }
    return <Typography style={{ color: colors }}>{value}</Typography>;
  }
},
 {
        field: 'present',
        headerName: 'Present',
        headerClassName: 'super-app-theme--header',
        minWidth: 50, flex: 1, align: 'center', headerAlign: 'center'
    },
    {
        field: 'absent',
        headerName: 'Absent',
        headerClassName: 'super-app-theme--header',
        minWidth: 50, flex: 1, align: 'center', headerAlign: 'center',
        
    },
   {
        field: 'present%',
        headerName: 'Percentage',
        type:'number',
        sortable:'true',
        headerClassName: 'super-app-theme--header',
        minWidth: 50, flex: 1, align: 'center', headerAlign: 'center',
        
    },
]
  useEffect(()=>{
    LocationShowdata(handleLocationshow,handleLocationshowException);
     FetchClassTypeShowData(handleTypeSuccess, handleTypeException );
  },[refreshData])

const handleTypeSuccess=(dataObject)=>{
setClassTypeDataList(dataObject.data)
}

const handleTypeException=()=>{

}
  const handleLocationshow=(dataObject)=>{
    setLocationList(dataObject?.data);
    console.log(dataObject?.data);
  }

  const handleLocationshowException=(error,errorMessage)=>{
    console.log(errorMessage);
  }

  const onLocationChange=(e)=>{
    setLocation(e.target.value);
    FetchBranchShowData({id:e.target.value},handleBranchSuccess, handleBranchException);
  }

  const handleBranchSuccess = (dataObject) =>{
    setBranchList(dataObject.data);
  }

  const handleBranchException= (errorStaus, errorMessage) =>{
    console.log(errorMessage);
  }

  const onBranchChange=(e)=>{
    setBranch(e.target.value); 
    FetchSpecializationShowData({id:e.target.value},handleSpecializationSuccess, handleSpecializationException);    
  }

  const handleSpecializationSuccess = (dataObject) =>{
    setSpecializationList(dataObject.data);
  }

  const handleSpecializationException= (errorStaus, errorMessage) =>{
    console.log(errorMessage);
  }

  const onSpecializationChange=(e)=>{
    setSpecialization(e.target.value);
    FetchSemesterShowData({id:e.target.value},handleSemesterSuccess, handleSemesterException);
  }

  const handleSemesterSuccess = (dataObject) =>{
    setSemesterList(dataObject.data);
  }

  const handleSemesterException= (errorStaus, errorMessage) =>{
    console.log(errorMessage);
  }

  const onSemesterChange=(e)=>{
    setSemester(e.target.value);
    GetSectionReport({ branch:branch,
      specialization:specialization,
      semester:e.target.value,
    },handleSectionSuccess, handleSectionException);
  }

  const handleSubjectSuccess = (dataObject) =>{
    console.log('data Branch');
    setSubjectList(dataObject.data);
  }

  const handleSubjectException= (errorStaus, errorMessage) =>{
    console.log(errorMessage);
  }

  const handleSectionSuccess = (dataObject) =>{
    setSectionList(dataObject.data);
  }

  const handleSectionException= (errorStaus, errorMessage) =>{
    console.log(errorMessage);
  }
    
  const onSectionChange=(e)=>{
    setSection(e.target.value);
    GetSubjectReport({id:e.target.value},handleSubjectSuccess, handleSubjectException);
  }

  const onSubjectChange =(e)=>{
    setSubject(e.target.value);
  }

  const onViewReport=()=>{
    GetStudentReportView({
      yearMonth:month,
      location :location,
      branch : branch,
      specialization: specialization,
      semester : semester ,
      section: section,
      subject:subject,
            classType:classType,

    },handleStudentReportView,handleStudentReportViewException)
  }
const handleStudentReportView = (dataObject) => {
    setLoading(true); // start loader

    // simulate API or processing delay
    setTimeout(() => {
      setRows(dataObject);
      setDownloadDisabled(false);
      setLoading(false); // stop loader after data is set
    }, 1000);
  };

  // const handleStudentReportView= (dataObject) =>{
  //   setRows(dataObject);
  //   setDownloadDisabled(false);
  // }
 const onClassTypeChange =(e)=>{
            setClassType(e.target.value);
            // onclassTypeChange(e.target.value);
    }
  const handleStudentReportViewException= (errorStaus, errorMessage) =>{
    console.log(errorMessage);
    setNotification({
      status: true,
      type: 'error',
      message: errorMessage,
    });
  }

  const onClickDownloadReport =()=>{
    DownloadStudentReport( { 
      yearMonth:month,
      location :location,
      branch : branch, 
      specialization: specialization ,
      semester: semester ,  
      section: section,
      subject: subject, 
      classType:classType,

    },handleStudentDownload,handleStudentDownloadException);  
  }
  
  const handleStudentDownload =()=> {
  }
  
  const handleStudentDownloadException =()=>{
  }

  const handleCloseNotify = () => {
    setNotification({
    status: false,
    type: '',
    message: '',
    });                                                                                                                                                                                                                 
  };

  return (
    <div style={{ height:870 , width: '98%',marginLeft:'5px' ,marginTop:'10px',overflow: "scroll",marginRight:'10px' }}>
      <StudentReportTools
        setIsAddButton={setIsAddButton}
        editClassName={editClassName}
        setEditClassName={setEditClassName}   
      />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
          <TextField 
          fullWidth 
          label="Month "
          placeholder='Month'
          variant="outlined"
          required
          type='month'
          value={month}
          onChange={(e) => setMonth(e.target.value) }
          InputLabelProps={
            {
              shrink:true
            }
          }/>
        </Grid>  
        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
          <FormControl fullWidth >
            <InputLabel id="demo-simple-select-label">Select Location</InputLabel>
            <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            label="Select Location"
            placeholder='Select Location'
            required
            value={location}
            onChange={(e) => onLocationChange(e) }>
            {
              locationList?.map((data, index) => {
                return (
                  <MenuItem value={data.id} key={index}>{data.location}</MenuItem>
                )
              })
            }      
            </Select>
          </FormControl>
        </Grid>  
        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Select Course</InputLabel>
            <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            label="Select Branch"
            placeholder='Select Branch'
            requiredvalue={branch}
            onChange={(e) => onBranchChange(e) }>
              {
                branchList.length !== 0 ? (
                  <MenuItem value="" key={0}>
                  <em>Select Course</em>
                  </MenuItem>
                )
              :
              ( <MenuItem value="" key={0}>
                  <em>Select Location </em>
                </MenuItem>
              )}
              {
                branchList?.map((data, index) => {
                  return (
                    <MenuItem value={data.id} key={index}>{data.branch}</MenuItem>
                  )
                })
              }  
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Select Specialization</InputLabel>
            <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            label="Select Specialization"
            placeholder='Select Specialization'
            value={specialization}
            required
            onChange={(e) => onSpecializationChange(e) }>
              {
                specializationList.length !== 0 ? (
                <MenuItem value="" key={0}>
                <em>Select Specialization</em>
                </MenuItem>
              )
            :
              ( <MenuItem value="" key={0}>
                  <em>Select Course </em>
                </MenuItem>
              )}
              {
                specializationList?.map((data, index) => {
                    return (
                      <MenuItem value={data.id} key={index}>{data.specialization}</MenuItem>
                    )
                })
              }       
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
          <FormControl fullWidth >
            <InputLabel id="demo-simple-select-label">Select Year</InputLabel>
            <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            label="Select Year"
            placeholder='Select Year'
            required
            value={semester}
            onChange={(e) => onSemesterChange(e) }>
            {
              semesterList.length !== 0 ? (
                <MenuItem value="" key={0}>
                  <em>Select Year</em>
                </MenuItem>
              )
              :
              (   <MenuItem value="" key={0}>
                <em>Select Specialization </em>
                </MenuItem>
              )}
              {
                semesterList?.map((data, index) => {
                  return (
                    <MenuItem value={data.id} key={index}>{data.semester}</MenuItem>
                  )
                })
              }      
            </Select>
          </FormControl>
        </Grid> 
        {/* <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Section</InputLabel>
            <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            label="Section"
            placeholder='Section'
            value={section}
            required
            onChange={(e) => onSectionChange(e) }>
              {
              sectionList.length !== 0 ? (
                <MenuItem value="" key={0}>
                <em>Select Section</em>
                </MenuItem>
              )
            :
            ( <MenuItem value="" key={0}>
                <em>Select Semester </em>
              </MenuItem>
            )}
            {
              sectionList?.map((data, index) => {
                return (
                  <MenuItem value={data.id} key={index}>{data.section}</MenuItem>
                )
              })
            }      
            </Select>
          </FormControl>
        </Grid >
        <Grid item xs={12} sm={3} md={3} lg={3} lx={3}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Subject</InputLabel>
            <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            label="Subject"
            placeholder='Subject'
            value={subject}
            onChange={(e) => onSubjectChange(e) }>
              {
                subjectList.length !== 0 ? (

                <MenuItem value="" key={0}>
                <em>Select Subject</em>
                </MenuItem>
                )
              :
                (   <MenuItem value="" key={0}>
                <em>Select Section </em>
                </MenuItem>
              )}
            {
            subjectList?.map((data, index) => {
              return (
                <MenuItem value={data.id} key={index}>{data.subject}</MenuItem>
              )
            })
            }      
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
                                  <FormControl fullWidth>
                                      <InputLabel id="demo-simple-select-label">Class Type</InputLabel>
                                      <Select
                                          labelId="demo-simple-select-label"
                                          id="demo-simple-select"
                                          label="Class Type"
                                          // required={!isConfirmationAudit}
                                          placeholder='Line'
                                          value={classType}
                                          onChange={(e) => onClassTypeChange(e)}
                                          style={{ fontSize: '14px', padding: '0px' }}
                                      // disabled={isConfirmationAudit}
                                      >
                                          {
                                              classTypedataList?.map((data, index) => {
                                                  return (
                                                      <MenuItem value={data.id} key={index}>{data.classTypeName}</MenuItem>
                                                  )
                                              })}
                                      </Select>
                                  </FormControl>
                              </Grid> */}
      </Grid>
      <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={1} mt={1}>
        <Grid item>
          <Button variant="contained" disabled={downloadDisabled} onClick={onClickDownloadReport}>DownLoad</Button>
        </Grid>
        <Grid item >
          <Button variant="contained" onClick={onViewReport}>View</Button>
        </Grid> 
      </Grid>
     <Grid style={{ marginTop: '20px' }}>
      {loading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '480px',
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <DataGrid
          rows={rows}
          columns={columns}
          sx={{
            height: '100%',
            minHeight: '480px',
            width: '100%',
            '& .super-app-theme--header': {
              WebkitTextStrokeWidth: '0.6px',
            },
          }}
          pageSize={10}
          rowsPerPageOptions={[20]}
          disableSelectionOnClick
        />
      )}
    </Grid>
      <NotificationBar
      handleClose={handleCloseNotify}
      notificationContent={openNotification.message}
      openNotification={openNotification.status}
      type={openNotification.type}/>
    </div>
  )
}

export default StudentReport
